export default "__VITE_ASSET__CcjBD1_M__"